"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var CahtFilledSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M13,4 C14.0543618,4 14.9181651,4.81587779 14.9945143,5.85073766 L15,6 L15,11 C15,12.0543618 14.1841222,12.9181651 13.1492623,12.9945143 L13,13 L8.651,13 L5.77737049,14.9159565 C5.69523247,14.970721 5.59872084,14.999945 5.5,14.999945 C5.25454011,14.999945 5.05039163,14.8230698 5.00805567,14.5898206 L5,14.499945 L5,13 L4.85073766,12.9945143 C3.86762078,12.9219826 3.08213523,12.1387735 3.00604447,11.1566505 L3,11 L3,6 C3,4.9456382 3.81587779,4.08183488 4.85073766,4.00548574 L5,4 L13,4 Z" })));
};
CahtFilledSmall.displayName = 'CahtFilledSmall';
exports.default = CahtFilledSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=CahtFilledSmall.js.map